import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RETURN_TO_KEY } from "./msalConfig.js";
import { safeReturnTo } from "./safeReturnTo.js";

/**
 * Phase 342 — the `/auth/callback` route.
 *
 * <p>The MSAL redirect response is already consumed by the time this mounts (App's
 * boot sequence does initialize → handleRedirectPromise → setActiveAccount before it
 * renders the router), so the only job left is to put the client back where they were.</p>
 *
 * <p>The stash is a PATH, written by this app, and it is consumed exactly once — an
 * absolute or protocol-relative value (`//host`, and since #3115 `/\host` too) is discarded
 * rather than navigated to, so a poisoned sessionStorage entry cannot turn the callback into
 * an open redirect.</p>
 */
export function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    const stashed = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    navigate(safeReturnTo(stashed, "/"), { replace: true });
  }, [navigate]);
  return <div className="auth-loading">Signing you in…</div>;
}
